import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import apiKnowledgeArticle from "../api";
import { KB_STATUS_META } from "../article-builder/blocks.data";

// Advanced filter fields for the article list. Each `key` is a
// tbl_knowledge_article column, which the get-all API filters on directly.
export const articleFilterFields = [
  { key: "knowledge_base_fid", label: "Knowledge Base", type: "select", group: "Article", optionsKey: "knowledgeBases", optionLabel: "title" },
  {
    key: "status",
    label: "Publish Status",
    type: "enum",
    group: "Article",
    options: Object.entries(KB_STATUS_META).map(([value, meta]) => ({ value, label: meta.label })),
  },
  { ...STATUS_FIELD, group: "Article" },
  { key: "order", label: "Order", type: "int", group: "Article" },
  { key: "published_at", label: "Published Date", type: "datetime", group: "Dates" },
  { key: "scheduled_at", label: "Scheduled Date", type: "datetime", group: "Dates" },
  { key: "updated_date", label: "Last Updated", type: "datetime", group: "Dates" },
  { key: "created_date", label: "Created Date", type: "datetime", group: "Dates" },
];

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadArticleFilterDependencies = async () => {
  const [knowledgeBasesRes] = await Promise.allSettled([apiKnowledgeArticle.getKnowledgeBasesForDropdown()]);
  return {
    knowledgeBases: knowledgeBasesRes.status === "fulfilled" ? knowledgeBasesRes.value?.data?.data || [] : [],
  };
};
